import clsx from "clsx"

import { getStyles } from "./utils";

interface IIconProps {
  src: string;
  lvl: 'first' | 'second' | 'third';
}

export const Icon = ({ src, lvl }: IIconProps) => {
  const styles = getStyles();
  return (
    <div className={clsx(styles['icon-border'], styles[lvl])}>
      <div className={styles['icon-bg']}>
        <img
          src={src}
          className={styles.icon}
        />
      </div>
    </div>
  )
}
